import React, { FC } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import map from 'lodash/map';
import { setCountryAction } from '../../../../redux/features/country';
import DropdownGeneric from '../../../DropdownGeneric/DropdownGeneric';

export type CountriesType = {
  code: string;
  img: string;
};

const CountriesSelect: FC<{ isDark: boolean; countries: CountriesType[] }> = ({
  isDark = false,
  countries,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { country } = useParams<{ country: string }>();

  const selected =
    countries.find((c) => c.code === country) || countries[0];

  const onSelected = (option: string) => {
    const parts = window.location.pathname.split('/');

    // El país siempre está en la posición 1
    parts[1] = option;

    // Truncar la ruta según keywords
    const keywords = new Set([
      'propiedades',
      'casas',
      'apartamentos',
      'proyectos',
    ]);

    const keywordIndex = parts.findIndex((seg) =>
      keywords.has(seg)
    );

    if (keywordIndex >= 0) {
      parts.length = keywordIndex + 1;
    }

    const newPath = parts.join('/');

    dispatch(setCountryAction({ country: option }));
    navigate(newPath);
  };

  const title = (
    <div className="flex items-center gap-1">
      <img
        className="w-8"
        src={get(selected, 'img')}
        alt={get(selected, 'code')}
      />
    </div>
  );

  const items = map(countries, ({ code, img }) => ({
    name: (
      <div className="flex items-center gap-2">
        <img className="w-8 rounded-[4px]" src={img} alt={code} />
        <p className="uppercase">{code}</p>
      </div>
    ),
    onClick: () => onSelected(code),
  }));

  return (
    <div className="dropdown-country">
      <DropdownGeneric
        title={title}
        items={items}
        isDark={isDark}
      />
    </div>
  );
};

export default CountriesSelect;
